import { type ReactNode } from "react";
import { AppShell } from "./shell/AppShell.js";

/**
 * Thin wrapper kept for backward compatibility with existing route wiring
 * (App.tsx renders <Layout> inside ProtectedRoute). All chrome lives in AppShell.
 */
export function Layout({ children }: { children: ReactNode }) {
  return <AppShell>{children}</AppShell>;
}
